export const productCard = {
  addToFavorites: "Add to favorites",
  removeFromFavorites: "Remove from favorites",
  moreOptions: "More options",
  tested: "Tested",
  thirdPartyTested: "Third party tested",
  quickView: "Quick view",
  compare: "Compare",
  heatSensitive: "Heat sensitive",
  shortShelfLife: "Short shelf life of 6 months or less",
} as const;
